import React, { useState } from 'react';

const ImagePreview = ({ url, filename }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [zoom, setZoom] = useState(1);

  const handleZoomIn = () => setZoom(prev => Math.min(prev + 0.25, 3));
  const handleZoomOut = () => setZoom(prev => Math.max(prev - 0.25, 0.25));
  const handleResetZoom = () => setZoom(1);

  return (
    <div className="bg-gray-100 rounded-lg overflow-hidden min-h-96">
      <div className="bg-white p-4 border-b flex justify-between items-center">
        <p className="text-sm text-gray-600">Image Preview</p>
        <div className="flex items-center gap-2">
          <button
            onClick={handleZoomOut}
            className="px-2 py-1 text-xs bg-gray-200 rounded hover:bg-gray-300"
          >
            Zoom Out
          </button>
          <span className="text-xs text-gray-600 min-w-12 text-center">
            {Math.round(zoom * 100)}%
          </span>
          <button
            onClick={handleZoomIn}
            className="px-2 py-1 text-xs bg-gray-200 rounded hover:bg-gray-300"
          >
            Zoom In
          </button>
          <button
            onClick={handleResetZoom}
            className="px-2 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Reset
          </button>
        </div>
      </div>
      <div className="p-4 h-96 overflow-auto flex items-center justify-center">
        {loading && (
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        )}
        {error && (
          <div className="text-red-500 text-center">
            <p>Failed to load image</p>
          </div>
        )}
        <img
          src={url}
          alt={filename}
          style={{ transform: `scale(${zoom})` }}
          className="max-w-full max-h-full object-contain transition-transform duration-200 rounded shadow-lg"
          onLoad={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            setError(true);
          }}
        />
      </div>
    </div>
  );
};

export default ImagePreview;